// buildReferralLink собирает ссылку mini app из фронтового app id и токена.
export function buildReferralLink(token) {
    const appID = process.env.REACT_APP_VK_APP_ID;
    if (!appID) {
        throw new Error("REACT_APP_VK_APP_ID is empty");
    }

    return `https://vk.com/app${appID}#referral_token=${encodeURIComponent(token)}`;
}
